import * as React from "react";

interface WhenProps {
    test: string;
    children?: React.ReactNode;
}

export function When(props: WhenProps): JSX.Element {
    return <span>{props.children}</span>;
}
